"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSettableDictateAbortable;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSettableDictateAbortable() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      dictateAbortable = _useWebChatUIContext.dictateAbortable,
      setDictateAbortable = _useWebChatUIContext.setDictateAbortable;

  return [dictateAbortable, setDictateAbortable];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZXR0YWJsZURpY3RhdGVBYm9ydGFibGUiLCJ1c2VXZWJDaGF0VUlDb250ZXh0IiwiZGljdGF0ZUFib3J0YWJsZSIsInNldERpY3RhdGVBYm9ydGFibGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTZXR0YWJsZURpY3RhdGVBYm9ydGFibGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2V0dGFibGVEaWN0YXRlQWJvcnRhYmxlKCkge1xuICBjb25zdCB7IGRpY3RhdGVBYm9ydGFibGUsIHNldERpY3RhdGVBYm9ydGFibGUgfSA9IHVzZVdlYkNoYXRVSUNvbnRleHQoKTtcblxuICByZXR1cm4gW2RpY3RhdGVBYm9ydGFibGUsIHNldERpY3RhdGVBYm9ydGFibGVdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSwyQkFBVCxHQUF1QztFQUNwRCwyQkFBa0QsSUFBQUMsNkJBQUEsR0FBbEQ7RUFBQSxJQUFRQyxnQkFBUix3QkFBUUEsZ0JBQVI7RUFBQSxJQUEwQkMsbUJBQTFCLHdCQUEwQkEsbUJBQTFCOztFQUVBLE9BQU8sQ0FBQ0QsZ0JBQUQsRUFBbUJDLG1CQUFuQixDQUFQO0FBQ0QifQ==